import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1f937cf0"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "teaching-header"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 0,
  class: "header-right"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/index.html",
  class: "link-btn",
  target: "_blank"
}, "门户首页", -1));

const _hoisted_5 = ["href"];
const _hoisted_6 = {
  class: "user-info"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "user-name"
};

const _hoisted_9 = /*#__PURE__*/_createTextVNode("退出");

import { getStorage, setStorage } from '@/plugins/store';
import { getCookie, handleLogout } from '@/plugins/utils.js';
export default {
  emits: ['getUserInfo'],

  setup(__props, {
    emit
  }) {
    const $http = inject('$http');
    const adminUrl = `${window.location.origin}/admin/`; // 基础配置信息

    const logoUrl = ref('');

    const getBaseSet = async () => {
      const res = getStorage('projectBaseData') || {};
      logoUrl.value = res.home_logo_url || '';
    };

    getBaseSet(); // 获取用户信息

    const userInfo = ref();

    const getUserInfo = async () => {
      let token = getCookie('X-Access-Token');

      if (token) {
        const res = await $http.getUserInfo();
        userInfo.value = res;
        emit('getUserInfo', res);
        setStorage('userInfo', res);
        console.log('用户信息', res);
      }
    };

    getUserInfo();
    return (_ctx, _cache) => {
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

      const _component_el_dropdown = _resolveComponent("el-dropdown");

      return _openBlock(), _createElementBlock("header", _hoisted_1, [_createElementVNode("img", {
        src: logoUrl.value,
        class: "school-logo",
        alt: ""
      }, null, 8, _hoisted_2), userInfo.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_hoisted_4, userInfo.value.roleId ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: `${adminUrl}`,
        class: "link-btn last-btn",
        target: "_blank"
      }, " 管理后台 ", 8, _hoisted_5)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
        src: userInfo.value.avatar || require('@/assets/images/common/teacher_icon.png'),
        class: "user-headimg",
        alt: ""
      }, null, 8, _hoisted_7), _createVNode(_component_el_dropdown, {
        trigger: "hover",
        "append-to-body": false,
        "show-arrow": false
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            onClick: _unref(handleLogout)
          }, {
            default: _withCtx(() => [_hoisted_9]),
            _: 1
          }, 8, ["onClick"])]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("span", _hoisted_8, _toDisplayString(userInfo.value.realname), 1)]),
        _: 1
      })])])) : _createCommentVNode("", true)]);
    };
  }

};